import config from 'src/config';
import { i18n } from 'src/i18n';
import Permissions from 'src/security/permissions';

import {
  BarChart3,
  Bell,
  Blocks,
  Building2,
  CreditCard,
  FileSearch,
  Folder,
  Home,
  Key,
  KeyRound,
  List,
  Map,
  PieChart,
  Rocket,
  Settings,
  Smartphone,
  StepForward,
  UserPlus,
  Workflow,
} from 'lucide-react';

const permissions = Permissions.values;

export default [
  {
    path: '/',
    exact: true,
    icon: <Home className="h-4 w-4" />,
    label: i18n('dashboard.home'),
    permissionRequired: null,
  },
  // {
  //   path: '/dashboard-operational',
  //   exact: true,
  //   icon: <BarChartOutlined />,
  //   label: i18n('dashboard.menu'),
  //   permissionRequired: null,
  // },

  config.isPlanEnabled && {
    path: '/plan',
    permissionRequired: permissions.planRead,
    icon: <CreditCard className="h-4 w-4" />,
    label: i18n('plan.menu'),
  },

  {
    path: '/user',
    label: i18n('user.menu'),
    permissionRequired: permissions.userRead,
    icon: <UserPlus className="h-4 w-4" />,
  },
  {
    path: '/api-key',
    permissionRequired: permissions.apiKeyRead,
    icon: <Key className="h-4 w-4" />,
    label: i18n('entities.apiKey.menu'),
  },
  {
    path: '/app-user',
    permissionRequired: permissions.appUserRead,
    icon: <Smartphone className="h-4 w-4" />,
    label: i18n('entities.appUser.menu'),
  },
  {
    path: '/audit-logs',
    icon: <FileSearch className="h-4 w-4" />,
    label: i18n('auditLog.menu'),
    permissionRequired: permissions.auditLogRead,
  },

  {
    path: '/settings',
    icon: <Settings className="h-4 w-4" />,
    label: i18n('settings.menu'),
    permissionRequired: permissions.settingsEdit,
  },
  {
    path: '/indicator',
    permissionRequired: permissions.indicatorRead,
    icon: <BarChart3 className="h-4 w-4" />,
    label: i18n('entities.indicator.menu'),
  },
  {
    path: '/location',
    permissionRequired: permissions.locationRead,
    icon: <Map className="h-4 w-4" />,
    label: i18n('entities.location.menu'),
  },

  {
    path: '/resource',
    permissionRequired: permissions.resourceRead,
    icon: <Folder className="h-4 w-4" />,
    label: i18n('entities.resource.menu'),
  },

  {
    path: '/keyword',
    permissionRequired: permissions.keywordRead,
    icon: <KeyRound className="h-4 w-4" />,
    label: i18n('entities.keyword.menu'),
  },

  {
    path: '/form-category',
    permissionRequired: permissions.formCategoryRead,
    icon: <List className="h-4 w-4" />,
    label: i18n('entities.formCategory.menu'),
  },

  {
    path: '/asset',
    permissionRequired: permissions.assetRead,
    icon: <Building2 className="h-4 w-4" />,
    label: i18n('entities.asset.menu'),
  },

  {
    path: '/notification',
    permissionRequired: permissions.notificationRead,
    icon: <Bell className="h-4 w-4" />,
    label: i18n('entities.notification.menu'),
  },

  {
    path: '/form-template',
    permissionRequired: permissions.formTemplateRead,
    icon: <Blocks className="h-4 w-4" />,
    label: i18n('entities.formTemplate.menu'),
  },

  {
    path: '/workflow',
    permissionRequired: permissions.workflowRead,
    icon: <Workflow className="h-4 w-4" />,
    label: i18n('entities.workflow.menu'),
  },
  {
    path: '/workflow-launch',
    permissionRequired: permissions.workflowLaunchRead,
    icon: <Rocket className="h-4 w-4" />,
    label: i18n('entities.workflowLaunch.menu'),
  },
  {
    path: '/flow-step',
    permissionRequired: permissions.flowStepRead,
    icon: <StepForward className="h-4 w-4" />,
    label: i18n('entities.flowStep.menu'),
  },
  {
    path: '/data-studio',
    permissionRequired: permissions.dataStudioRead,
    icon: <PieChart className="h-4 w-4" />,
    label: i18n('entities.dataStudio.menu'),
  },
].filter(Boolean);
